import { Alert } from '@/components/Alert';
import { BodySmall, HeaderXSmall } from '@/components/Typography';

export const CoverageRequirementsAlertV2 = () => {
  return (
    <Alert
      severity="info"
      iconPosition="start"
      sx={{ mb: 3 }}
      dataTestId="coverage-requirements-alert"
    >
      <HeaderXSmall data-testid="coverage-requirements-alert-title">
        Information on coverage requirements
      </HeaderXSmall>
      <BodySmall
        data-testid="coverage-requirements-alert-message"
        sx={{ color: 'text.primary', lineHeight: '24px' }}
      >
        Your company default for Rent and Deposit Coverage will be automatically applied to this
        deal and coverage cannot be customized.
      </BodySmall>
    </Alert>
  );
};
